"use client";

import { FC, PropsWithChildren, useEffect, useState } from "react";
import MediaQueryResponsive from "react-responsive";

export const MOBILE_MEDIA_QUERY = "(max-width: 1023px)";
export const LAPTOP_MEDIA_QUERY = "(min-width: 1024px)";

const Mobile: FC<PropsWithChildren> = ({ children }) => {
  const [isMounted, setIsMounted] = useState(false);

  useEffect(() => {
    setIsMounted(true);
  }, []);

  return isMounted ? <MediaQueryResponsive maxWidth={1023}>{children}</MediaQueryResponsive> : null;
};

const Laptop: FC<PropsWithChildren> = ({ children }) => {
  const [isMounted, setIsMounted] = useState(false);

  useEffect(() => {
    setIsMounted(true);
  }, []);

  return isMounted ? <MediaQueryResponsive minWidth={1024}>{children}</MediaQueryResponsive> : null;
};

export const MediaQuery = {
  Mobile,
  Laptop,
};
